export interface Employees {
    id: number;
    name: string;
    dni: string;
    phone: number;
    email: string;
    birth_date: string | null;
    address: string;
    city: string;
    province: string;
    country: string;
    postal_code: number;
    irpf: number;
    workday: number;
    marital_status: number;
    children: number;
    property_type: number;
    category: string;
    contract_type: number;
    bank_account: string;
    active: boolean;
    users_id: number;
    activities_id: number;
    accountingmodels_id: number;
    password: string;
    guid: string;
    signature: string;
    salary: any;

    activarGeolocalizacion: boolean;
    geolocalizacionAceptada: boolean;
    geolocalizacionAceptadaFecha: Date | null;
}

export interface EmployeesSignature_DTO {
    signature: string;
}

/**
 * Nombres de los empleados predefinidos.
 * Estos nombres se utilizan para los empleados que se crean automáticamente.
 * No se pueden modificar ni eliminar.
 */
export const EMPLOYEES_PREDEFINED_NAMES = [
    "Empleados_Por_Trimestre",
    "Empleados_Por_Mes",
    "Empleados_Por_Año",
];
